import React, { useMemo, useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';
import { SVGPureIcon } from '@/ui';

const McpToolsCost = observer((props) => {
  const {
    className = '',
    item,
    mcpStore,
  } = props;

  const [folded, setFolded] = useState(false);
  const toggleFolded = () => {
    setFolded(v => !v);
  }

  const costList = useMemo(() => {
    try{
      const list = JSON.parse(item.content);
      return list;
    } catch(e){}
    return [];
  }, [item]);

  if(!costList.length){
    return null;
  }

  return (
    <div className={`mcp-tools ui-tools-box border-1px border-black border-opacity-10 hover:border-opacity-30 bg-white ${className}`}>
      <div 
        className={`flex items-center select-none w-full cursor-pointer`}
        onClick={toggleFolded}
        >
        <div className="size-16px mr-10px">
          <SVGPureIcon name="warning_circle2" />
        </div>
        <div className="text-container text-16px leading-18px mr-10px flex h-full items-center w-0 flex-grow">
          <div className="font-bold">本次任务详情</div>
        </div>
        <div className={`size-16px transition-transform transition-[0.25s] transform flex items-center justify-center ${folded ? 'rotate-[180deg]' : ''}`}>
          <SVGPureIcon className='size-12px' name="mcp_left_card_fold" />
        </div>
      </div>
      {
        folded
        ? null
        : (
          <ul className='pt-16px pl-26px list-disc'>
            {
              costList.map(item => {
                return (
                  <li 
                    key={item}
                    className='leading-18px mb-12px last-of-type:mb-0'>
                    {item}
                  </li>
                )
              })
            }
          </ul>
        )
      }
    </div>
  )
});
export default McpToolsCost;